import React from 'react';

import { fg } from '@confluence/feature-gating';

import { Bm3PageLoadEnd } from '../Bm3PageLoadEnd.tsx';
import type { Props } from '../Bm3PageLoadEnd.tsx';

import { UFOLoadEnd } from './UFOLoadEnd.tsx';

/**
 * Interop component that renders either the new UFOLoadEnd (which calls
 * addUFOCustomData directly) or the legacy Bm3PageLoadEnd (which feeds data
 * through BM3) based on the `confluence_fe_deprecate_bm3` feature gate.
 */
export const PageLoadEnd = (props: Props) => {
	if (fg('confluence_fe_deprecate_bm3')) {
		return <UFOLoadEnd {...props} />;
	}

	return <Bm3PageLoadEnd {...props} />;
};
